import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-land-rec-details',
  templateUrl: './land-rec-details.component.html',
  styleUrls: ['./land-rec-details.component.css']
})
export class LandRecDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/land-rec-details/land-rec-details.component.ts